/**
 * PlaygroundAROrbPlaygroundRoute
 *
 * Page component for PlaygroundAROrbPlaygroundRoute
 * Path: /ar/playground
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PlaygroundAROrbPlaygroundPageView as __PlaygroundAROrbPlaygroundPageView } from '@/components/traits/PlaygroundAROrbPlaygroundPageView';
import { PlaygroundAROrbPlaygroundAnalyticsView as __PlaygroundAROrbPlaygroundAnalyticsView } from '@/components/traits/PlaygroundAROrbPlaygroundAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface PlaygroundAROrbPlaygroundRouteProps {
  // Add any page-level props here
}

export function PlaygroundAROrbPlaygroundRoute(_props: PlaygroundAROrbPlaygroundRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-playground:meta.title"],"description":["i18n/t","std-orb-playground:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/playground"},{"locale":"ar","path":"/ar/playground"},{"locale":"sl","path":"/sl/playground"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PlaygroundAROrbPlaygroundPageView config={{ initPayload: __navState }} />
          <__PlaygroundAROrbPlaygroundAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default PlaygroundAROrbPlaygroundRoute;
